import React from "react"
import Logo from "./logo"
import { Link } from "gatsby"

const Header = () => {
  return (
    <header className={`fixed top-0 left-0 z-30`}>
      <Link to={`/`}>
        <Logo className={`text-red w-20 lg:w-40 pt-6 pl-4 lg:pt-8 lg:pl-6`} />
      </Link>
    </header>
  )
}

export default Header
